export default __webpack_public_path__ + "static/media/airtable.dad69f31.svg";